/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

export type ProjectType = (typeof ProjectType)[keyof typeof ProjectType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectType = {
  project: 'project',
} as const;
